import { DiscountDatesState, DiscountDateRange } from "app/pages/DiscountEditor/modules/DiscountDates/state";
import { Action, ActionType, DateType, DateRangeField } from "app/pages/DiscountEditor/actionTypes";
import * as dateFns from 'date-fns';
import { DiscountDateRangeDto } from "app/shared/model/DiscountDto";

const startingState : DiscountDatesState = {
    bookingDateRange: { from: '', to: '', neverExpires: false }, 
    productDateRange: { from: '', to: '', neverExpires: false }
}

export function reducer(state: DiscountDatesState|undefined, action: Action) : DiscountDatesState {
    if (!state) {
        return startingState;
    }

    switch(action.type) {
        case ActionType.SetDate: 
            return applySetDate(state, action.dateType, action.dateField, action.value); 
        case ActionType.DateNeverExpires: 
            return applyDateNeverExpires(state, action.dateType, action.value);
        case ActionType.PageLoaded:
            return {
                bookingDateRange: parseDateRangeDto(!action.data.id, action.discount.datesFilter.bookingDateRange),
                productDateRange: parseDateRangeDto(!action.data.id, action.discount.datesFilter.productDateRange) 
            };
        default:
            return state;
    }
}

function parseDateRangeDto(isNewRec: boolean, dto: DiscountDateRangeDto) : DiscountDateRange {
    return {
        from: dto.from || '',
        to: dto.to || '',
        neverExpires: !dto.to && !isNewRec
    }
}

function applySetDate(
    state: DiscountDatesState, 
    dateType: DateType, 
    dateField: DateRangeField, 
    date: string) : DiscountDatesState {        
        switch(dateType){
            case DateType.Booking: 
                const bookingRange = getNewDateRange(state.bookingDateRange, dateField, date); 
                return Object.assign({}, state, { bookingDateRange: bookingRange }); 
            case DateType.Product: 
                const productRange = getNewDateRange(state.productDateRange, dateField, date); 
                return Object.assign({}, state, { productDateRange: productRange }); 
            default: 
                return state; 
        }
}

function getNewDateRange(
    dateRange: DiscountDateRange, 
    field: DateRangeField, 
    newDate: string) : DiscountDateRange
{
    switch (field)
    {
        case DateRangeField.From: 
            let dateToStr = (newDate !== '' && dateRange.to !== '' && dateFns.isAfter(dateFns.parseISO(newDate), dateFns.parseISO(dateRange.to)))
                ? '' : dateRange.to; 
            return createDiscountDateRange(newDate, dateToStr, dateRange.neverExpires); 
        case DateRangeField.To: 
            let dateFromStr = (newDate !== '' && dateRange.from !== '' && dateFns.isBefore(dateFns.parseISO(newDate), dateFns.parseISO(dateRange.from)))
                ? '' : dateRange.from; 
            return createDiscountDateRange(dateFromStr, newDate, dateRange.neverExpires); 
        default: 
            return dateRange; 
    }
}

function applyDateNeverExpires(
    state: DiscountDatesState, 
    dateType: DateType, 
    isNeverExpires: boolean) : DiscountDatesState {
        switch(dateType){
            case DateType.Booking: 
                return Object.assign({}, state, {
                    bookingDateRange: 
                        createDiscountDateRange(
                            state.bookingDateRange.from, 
                            state.bookingDateRange.to, 
                            isNeverExpires)
                    }); 
            case DateType.Product: 
                return Object.assign({}, state, {
                    productDateRange: 
                        createDiscountDateRange(
                            state.productDateRange.from, 
                            state.productDateRange.to, 
                            isNeverExpires)
                    }); 
            default: 
                return state; 
        }
}

function createDiscountDateRange(from: string, to: string, neverExpires: boolean) : DiscountDateRange {
    return {
        from: from, 
        to: to, 
        neverExpires: neverExpires
    }
}

